import { fetchData, setHeaderOptions } from "#/api/apiHelpers";

const ROUTE = "/admin/articles/ai-policy";

export type ArticleAiPolicy = {
  policyKey: string;
  audience: string;
  readingLevel: string;
  doRules: string[];
  dontRules: string[];
  generationInstructions: string;
  revisionInstructions: string;
  reviewInstructions?: string;
  mediaGenerationInstructions?: string;
  mediaReviewInstructions?: string;
  topicOverrides?: Record<string, {
    generationInstructions?: string;
    revisionInstructions?: string;
  }>;
};

export type ArticleAiPolicyResponse = {
  slug: string;
  policy: ArticleAiPolicy;
  template?: { id: string } | null;
  activeVersion?: { id: string; version: string; created_at: string } | null;
};

export async function getArticleAiPolicy(
  options?: { signal?: AbortSignal }
): Promise<ArticleAiPolicyResponse> {
  const request = setHeaderOptions({ method: "GET" });
  return fetchData<ArticleAiPolicyResponse>(ROUTE, {
    ...request,
    signal: options?.signal,
  });
}

export async function updateArticleAiPolicy(payload: {
  policy: ArticleAiPolicy;
  publish?: boolean;
}): Promise<ArticleAiPolicyResponse> {
  const request = setHeaderOptions({
    method: "PUT",
    body: payload,
  });
  return fetchData<ArticleAiPolicyResponse>(ROUTE, request);
}
